import { globalEnvironment } from '../../../../environments/environment.prod';
import { BaseApplication, BaseApplicationLogo, businessTag } from 'base';

export const environment = {
  global: globalEnvironment,
  env: 'prod',
  application: {
    project: 'Stazzle business',
    app: BaseApplication.business,
    tag: businessTag,
    logo: BaseApplicationLogo.business,
    logoSystemPage: BaseApplicationLogo.systemPage,
    logoSystemPageSmall: BaseApplicationLogo.systemPageSmall,
  },
};
